"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Banner_1 = __importDefault(require("./Banner"));
var Testimonial_1 = __importDefault(require("./Testimonial"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Testimonials = function (_a) {
    var testimonials = _a.testimonials;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Banner_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, testimonials.map(function (item, idx) { return (react_1.default.createElement(Testimonial_1.default, __assign({ key: "".concat(item.title) }, item))); })))));
};
exports.default = Testimonials;
